import auth from "./auth";
import user from "./user";
import ticket from "./ticket";
import options from "./options";
import helper from "./helpers";
import notification from "./notification";
import faq from "./faq";
export default {
  auth,
  user,
  ticket,
  options,
  helper,
  notification,
  faq,
};
